"use strict";
// (C) 2019-2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomWorkspace = void 0;
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var execution_1 = require("./execution");
/**
 * @internal
 */
var CustomWorkspace = /** @class */ (function () {
    function CustomWorkspace(workspace, config, state) {
        this.workspace = workspace;
        this.config = config;
        this.state = state;
    }
    CustomWorkspace.prototype.getDescriptor = function () {
        throw new sdk_backend_spi_1.NotSupported("getting workspace descriptor is not supported");
    };
    CustomWorkspace.prototype.getParentWorkspace = function () {
        throw new sdk_backend_spi_1.NotSupported("getting parent workspace is not supported");
    };
    CustomWorkspace.prototype.execution = function () {
        return new execution_1.CustomExecutionFactory(this.workspace, this.config, this.state);
    };
    //
    // Should implement
    //
    // used by attribute filters
    CustomWorkspace.prototype.attributes = function () {
        throw new sdk_backend_spi_1.NotSupported("attributes service is not supported");
    };
    // used in InsightView - implement if custom backend should support persisted insights
    CustomWorkspace.prototype.settings = function () {
        throw new sdk_backend_spi_1.NotSupported("settings not supported");
    };
    // used in InsightView - implement if custom backend should support persisted insights
    CustomWorkspace.prototype.styling = function () {
        throw new sdk_backend_spi_1.NotSupported("styling is not supported");
    };
    //
    // Services for 'advanced' use cases - used in AD and KD.
    //
    CustomWorkspace.prototype.permissions = function () {
        throw new sdk_backend_spi_1.NotSupported("permissions are not supported");
    };
    CustomWorkspace.prototype.catalog = function () {
        throw new sdk_backend_spi_1.NotSupported("catalog is not supported");
    };
    CustomWorkspace.prototype.measures = function () {
        throw new sdk_backend_spi_1.NotSupported("measures service is not supported");
    };
    CustomWorkspace.prototype.facts = function () {
        throw new sdk_backend_spi_1.NotSupported("measures service is not supported");
    };
    CustomWorkspace.prototype.datasets = function () {
        throw new sdk_backend_spi_1.NotSupported("data sets service is not supported");
    };
    CustomWorkspace.prototype.insights = function () {
        throw new sdk_backend_spi_1.NotSupported("insights are not supported");
    };
    CustomWorkspace.prototype.dashboards = function () {
        throw new sdk_backend_spi_1.NotSupported("dashboards are not supported");
    };
    CustomWorkspace.prototype.users = function () {
        throw new sdk_backend_spi_1.NotSupported("users are not supported");
    };
    CustomWorkspace.prototype.dateFilterConfigs = function () {
        throw new sdk_backend_spi_1.NotSupported("dateFilterConfigs are not supported");
    };
    CustomWorkspace.prototype.userGroups = function () {
        throw new sdk_backend_spi_1.NotSupported("user groups are not supported");
    };
    CustomWorkspace.prototype.accessControl = function () {
        throw new sdk_backend_spi_1.NotSupported("access control is not supported");
    };
    return CustomWorkspace;
}());
exports.CustomWorkspace = CustomWorkspace;
//# sourceMappingURL=workspace.js.map